import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import imgEmpty from '~/assets/logo/empty.png'

const { Text, Title } = Typography;

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('blog');
  const navigateDetailBlog = (documentId) => {
    navigate(`/blog/${documentId}`);
  };

  return (
    <Link to={`/blog/${blog.documentId}`} style={{textDecoration: 'none'}}>
      <Card 
            onClick={() => navigateDetailBlog(blog.documentId)}
            cover={
                <img
                    className="blog-item-image"
                    src={ blog?.image?.url || imgEmpty}
                    alt="Blog Thumbnail"
                />
            }>
            <div className="blog-item-content">
                <Title className="blog-item-title" level={4} style={{ margin: 0 }}>{blog.title}</Title>
                <Text className="blog-item-desc">
            {blog.shortDesc}
                </Text>
            </div>
        </Card>
    </Link>
  );
};

export default BlogCard;